import * as ng from 'angular';

export const FormatFilename: ng.FilterFactory = ($filter: ng.IFilterService) => {
    return (filename: any, max: any) => {
        if (filename === undefined) {
            return;
        } else {
            let filenameLength = filename.length;
            if (filename.replace(' ', '').length > (max + 3)) {
                return filename.substr(0, Math.floor(max / 2)).trim() + '...' + filename.substr(filenameLength - Math.floor(max / 2), filenameLength).trim();
            }
            return filename;
        }
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/format-filename.filter.ts